import http from "@/http-common";

export default class CustAreaService {

	getList(_params) {
		return http.get('/ma/custareas', { params: _params}).then(res => res.data);
	}

	getOne(_Id) {
		return http.get(`/ma/custareas/${_Id}`).then(res => res.data);
	}

	insertOne(_data) {
		return http.post('/ma/custareas',_data).then(res => res.data);
	}

	updateOne(_data) {
		return http.put('/ma/custareas',_data).then(res => res.data);
	}

	deleteOne( _compSeq, _custSeq, _publicSeq, _areaSeq)
	{
		return http.delete(`/ma/custareas/${_compSeq}/${_custSeq}/${_publicSeq}/${_areaSeq}`).then(res => res.data);
	}

	deleteList( _data)
	{
		return http.delete('/ma/custareas/', {data:JSON.stringify(_data)}).then(res => res.data);
	}

}